import { FC, MouseEvent, useState } from "react"
import { Check, Copy } from "lucide-react"
import { useAppDispatch } from "../../hooks"
import { pushToast } from "../../../redux/slices/notifications"
import { copyToClipboard } from "../../utils"

interface Props {
  text: string
  ariaLabel?: string
}

const CopyTextButton: FC<Props> = ({
  text,
  ariaLabel = "Copy to clipboard"
}) => {
  const dispatch = useAppDispatch()
  const [copied, setCopied] = useState(false)

  const handleCopy = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()

    try {
      await copyToClipboard(text)
      setCopied(true)
      dispatch(
        pushToast({
          msg: "Copied to clipboard",
          theme: "success",
          timeout: 2000
        })
      )
      setTimeout(() => setCopied(false), 2000)
    } catch {
      dispatch(
        pushToast({
          msg: "Failed to copy to clipboard",
          theme: "danger",
          timeout: 2000
        })
      )
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label={ariaLabel}
      className="relative z-10 rounded p-1 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-700"
    >
      {copied ? <Check size={14} /> : <Copy size={14} />}
    </button>
  )
}

export default CopyTextButton
